import React, { useEffect, useState, useCallback } from 'react';
import { Table, SearchInputColumn } from 'components';
import { FormDetail } from './form-detail';
import { Box, Button, Typography } from '@mui/material';
import { BsPlusCircle } from 'react-icons/bs';
import ApiServices from 'services';
import { ContainerHeader, ButtonAdd } from './styles';
import Utils from 'commons/utils';
import { debounce } from 'lodash';

function PermissionMemberGroup() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [filter, setFilter] = useState(null);
  const [originData, setOriginData] = useState([]);

  const initData = async () => {
    setLoading(true);
    try {
      const res = await ApiServices.getPermissionMemberGroups();
      if (res?.data) {
        setData(res?.data || []);
        setOriginData(res?.data || []);
      }
    } catch (err) {
      console.warn('initData - Client Groups', err);
    }
    setLoading(false);
  };
  const getCompany = async () => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getCompanies();
      setCompanyList(data || []);
    } catch (err) {
      console.warn('initData - companies', err);
    }
    setLoading(false);
  };
  useEffect(() => {
    initData();
    getCompany();
  }, []);

  const handleFilterData = (query, dataInit) => {
    let dataFilter = [];
    dataInit?.map((item) => {
      let checkFilter = true;

      if (query?.code) {
        if (!Utils.convertValSearch(item?.code)?.includes(Utils.convertValSearch(query?.code))) {
          checkFilter = false;
        }
      }
      if (query?.name) {
        if (!Utils.convertValSearch(item?.name)?.includes(Utils.convertValSearch(query?.name))) {
          checkFilter = false;
        }
      }

      if (checkFilter) {
        dataFilter.push(item);
        return;
      } else {
        return;
      }
    });
    setData(dataFilter);
  };

  const timeoutGetData = useCallback(
    debounce((newFilter, dataInit) => {
      handleFilterData(newFilter, dataInit);
    }, 500),
    [],
  );

  useEffect(() => {
    if (originData?.length) {
      timeoutGetData(filter, originData);
    }
  }, [filter]);

  const onColumnSearch = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    setFilter((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const deleteCell = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.deletePermissionMemberGroup(row.id);

      if (res) {
        window.UIMessage?.success('Xóa thành công');
        initData();
      }
    } catch (err) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.warn('deleteCell - companies', err);
    }
    setLoading(false);
  };

  const displayCompany = (row) => {
    if (!row?.companyId) return;
    const company = companyList?.find((item) => item.id === row.companyId);
    if (!company) return;
    return company?.name;
  };

  const headCells = [
    {
      id: 'code',
      disablePadding: false,
      label: <SearchInputColumn name="code" title="Mã" onChange={onColumnSearch} />,
      width: 10,
      sort: true,
      align: 'center',
      sort: true,
    },
    {
      id: 'name',
      disablePadding: false,
      label: <SearchInputColumn name="name" title="Tên Nhóm" onChange={onColumnSearch} />,
      align: 'center',
      sort: true,
    },
    {
      id: 'desc',
      disablePadding: false,
      label: 'Mô tả',
      align: 'center',
    },
    {
      id: 'companyId',
      disablePadding: false,
      label: 'Công ty',
      align: 'center',
      render: displayCompany,
    },
    {
      id: 'actions',
      disablePadding: false,
      label: 'Thao tác',
      align: 'center',
      width: '10px',
      fixed: 'right',
      render: (row) => (
        <Button
          variant="contained"
          size="small"
          color="error"
          sx={{ borderRadius: '15px', textTransform: 'none' }}
          onClick={() => window.showConfirm(() => deleteCell(row))}
        >
          Xoá
        </Button>
      ),
    },
  ];

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <Typography variant="h6" component="h6" sx={{ m: '10px' }}>
          Nhóm Thành Viên
        </Typography>
      </ContainerHeader>
      <ButtonAdd
        variant="contained"
        startIcon={<BsPlusCircle />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </ButtonAdd>
    </>
  );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Table
          rows={data}
          headCells={headCells}
          onClickDetail={(row) => {
            setSelected(row);
          }}
          loading={loading}
          renderHeader={renderHeader}
        />
        <FormDetail {...{ selected, setSelected, initData }} />
      </Box>
    </>
  );
}
export { PermissionMemberGroup };
